import { Badge, Text } from '@change/ds-core-ui';
import { Form, SelectionCard, SelectionCardGroup } from '@change/ds-forms';
import { PetitionIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { StepActions } from 'src/app/pages/startAPetitionV2/shared/components';

import { useRecommendations } from './hooks/useRecommendations';

export const Recommendations: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = useRecommendations();

	return (
		<div
			className="container mx-auto mb-[88px] flex max-w-[620px] flex-col gap-6 px-5 py-8 md:gap-12"
			data-qa="recommendations-step"
		>
			<div className="grid gap-4">
				<Text as="h1" variant="heading" id="recommendations-heading" className="m-0">
					{translate('corgi.start_a_petition.recommendations.heading')}
				</Text>
				<Text as="p" variant="body" size="large" id="recommendations-description">
					<Translate value="corgi.start_a_petition.recommendations.description" />
				</Text>
			</div>

			<Form onSubmit={actions.submit} data-qa="recommendations-form">
				<SelectionCardGroup
					name="recommendation"
					label=""
					aria-labelledby="recommendations-heading recommendations-description"
					data-qa="recommendation-selection-card-group"
					defaultValue={data.defaultRecommendationId}
					className="[&>span:first-child]:hidden"
				>
					{data.recommendations.map((rec, i) => (
						<SelectionCard
							key={rec.id}
							data-qa={`recommendation-card-${i}`}
							value={rec.id}
							label={rec.recommendation}
							description={rec.why}
							selectToShowDescription
							badgeTop={
								i === 0 ? (
									<Badge
										variant="information"
										emphasis="weak"
										label={translate('corgi.start_a_petition.recommendations.recommendation_tag')}
										size="tiny"
									/>
								) : undefined
							}
						/>
					))}
					<SelectionCard
						data-qa="write-your-own-recommendation-card"
						value="write_your_own"
						label={translate('corgi.start_a_petition.recommendations.write_your_own')}
						icon={PetitionIcon}
					/>
				</SelectionCardGroup>

				<StepActions type="form" onSecondaryAction={actions.back} className="mt-12" />
			</Form>
		</div>
	);
};
